export class DistributionList {
  #id;
  #name;
  #slug
  constructor({ distributionListId, distributionName, generatedDistributionName }) {
    this.#id = distributionListId;
    this.#name = distributionName;
    this.#slug = generatedDistributionName;
  }

  get id() {
    return this.#id;
  }

  get name() {
    return this.#name;
  }

  get slug() {
    return this.#slug;
  }
}

export class DistributionListDetail {
  #distributionListId;
  #distributionOwnerUserId;
  #distributionName;
  #generatedDistributionName;
  #distributionCreatedDateTime;
  #distributionIsDeleted;
  #users;

  constructor({
    distributionListId_ids,
    distributionOwnerUserId_chr,
    distributionName_chr,
    generatedDistributionName_chr,
    distributionCreatedDateTime_dtm,
    distributionIsDeleted_ysn,
    users
  }) {
    this.#distributionListId = distributionListId_ids;
    this.#distributionOwnerUserId = distributionOwnerUserId_chr;
    this.#distributionName = distributionName_chr;
    this.#generatedDistributionName = generatedDistributionName_chr;
    this.#distributionCreatedDateTime = distributionCreatedDateTime_dtm;
    this.#distributionIsDeleted = distributionIsDeleted_ysn;
    this.#users = Array.isArray(users) ? users.map(user => new DistributionListUser(user)) : [];
  }

  get id() {
    return this.#distributionListId;
  }

  get name() {
    return this.#distributionName;
  }

  get slug() {
    return this.#generatedDistributionName;
  }

  get ownerUserId() {
    return this.#distributionOwnerUserId;
  }

  get createdDateTime() {
    return this.#distributionCreatedDateTime;
  }

  get isDeleted() {
    return this.#distributionIsDeleted;
  }

  get users() {
    return this.#users;
  }
}

export class DistributionListUser {
  #userId;
  #userName;
  #userAvatarImageUrl;
  #emailId;
  #normalizedEmailId;
  #joinedDateTime;
  #userDistributionIsDeleted;

  constructor({
    userId_chr,
    userName_chr,
    userAvatarImageUrl_chr,
    emailId_chr,
    normalizedEmailId_chr,
    joinedDateTime_dtm,
    userDistributionIsDeleted_ysn
  }) {
    this.#userId = userId_chr;
    this.#userName = userName_chr;
    this.#userAvatarImageUrl = userAvatarImageUrl_chr;
    this.#emailId = emailId_chr;
    this.#normalizedEmailId = normalizedEmailId_chr;
    this.#joinedDateTime = joinedDateTime_dtm;
    this.#userDistributionIsDeleted = userDistributionIsDeleted_ysn;
  }

  get id() {
    return this.#userId || this.#emailId;
  }

  get userId() {
    return this.#userId;
  }

  get userName() {
    return this.#userName;
  }

  get userAvatar() {
    return this.#userAvatarImageUrl;
  }

  get email() {
    return this.#emailId;
  }

  get normalizedEmail() {
    return this.#normalizedEmailId;
  }

  get joinedDateTime() {
    return this.#joinedDateTime;
  }

  get isDeleted() {
    return this.#userDistributionIsDeleted;
  }

  get username() {
    return this.#userName || (this.#emailId ? this.#emailId.split('@')[0] : null);
  }

  get avatar() {
    return this.#userAvatarImageUrl;
  }
}

export class DistributionListDetails extends DistributionList {
  constructor(user) {
    const { users } = user;
    super(user);
    this.users = users.map((user) => new UserInfo(user));
  }
}

export class UserInfo {
  #id;
  #username;
  #email;
  constructor({ id, username, email, avatar }) {
    this.#id = id;
    this.#username = username;
    this.#email = email;
    this.avatar = avatar;
  }

  get id() {
    return this.#id;
  }
  get username() {
    return this.#username;
  }
  get email() {
    return this.#email;
  }
}
